import {
	decodeBytes,
	encodeBytes,
	type Secp256k1,
} from "open-signer-shared-cryptography";
import type {
	CryptoStrategy,
	PublicKey,
	Signature,
} from "../crypto-key-strategy";

export class Secp256k1Strategy implements CryptoStrategy<"secp256k1"> {
	readonly keyType = "secp256k1" as const;

	constructor(private readonly secp256k1Service: Secp256k1) {}

	async getPrivateKeyFromSeed(seed: Uint8Array): Promise<Uint8Array> {
		return this.secp256k1Service.privateKeyFromSeed(seed);
	}

	async getPublicKey(privateKey: Uint8Array): Promise<Uint8Array> {
		return this.secp256k1Service.getPublicKey(privateKey);
	}

	// This strategy expects a 32-byte digest, which it passes to the service.
	async sign(privateKey: Uint8Array, digest: Uint8Array): Promise<Uint8Array> {
		const hexSignature = this.secp256k1Service.sign(digest, privateKey);
		return decodeBytes(hexSignature.slice(2), "hex");
	}

	formatPublicKey(publicKey: Uint8Array): PublicKey<"secp256k1"> {
		return {
			bytes: `0x${encodeBytes(publicKey, "hex")}`,
			encoding: "hex",
			keyType: "secp256k1",
		};
	}

	formatSignature(signature: Uint8Array): Signature<"secp256k1"> {
		return {
			bytes: `0x${encodeBytes(signature, "hex")}`,
			encoding: "hex",
			keyType: "secp256k1",
		};
	}
}
